webpackJsonp([5],{

/***/ "+CoK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "/* # Setup devices width */\n/* # Variables for mobile first approach and strict ranges */\n.limit-exceeded__message {\n  background: white;\n  border: 1px solid #bfbfbf;\n  text-align: left;\n  padding: 18px 20px;\n}\n@media only screen and (min-width: 768px) {\n.limit-exceeded__message {\n    padding: 18px 25px;\n}\n}\n@media only screen and (min-width: 1025px) {\n.limit-exceeded__message {\n    padding: 18px 35px;\n}\n}\n", "", {"version":3,"sources":["/var/www/jlr/booking-widget/src/components/LimitExceeded.vue"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,mBAAmB;CACtB;CACA","file":"LimitExceeded.vue","sourcesContent":["/* # Setup devices width */\n/* # Variables for mobile first approach and strict ranges */\n.limit-exceeded__message {\n  background: white;\n  border: 1px solid #bfbfbf;\n  text-align: left;\n  padding: 18px 20px;\n}\n@media only screen and (min-width: 768px) {\n.limit-exceeded__message {\n    padding: 18px 25px;\n}\n}\n@media only screen and (min-width: 1025px) {\n.limit-exceeded__message {\n    padding: 18px 35px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "/4dF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "/* # Setup devices width */\n/* # Variables for mobile first approach and strict ranges */\n.services__list[data-v-08a81ef8] {\n  text-align: left;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.services__item[data-v-08a81ef8] {\n  display: inline-block;\n}\n.land-rover-style .services__item[data-v-08a81ef8]::before {\n  width: 4px;\n  height: 4px;\n  content: '';\n  background: #696969;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 5px;\n}\n@media screen and (max-width: 1024px) {\n.jaguar-style .services__item[data-v-08a81ef8]::before {\n    width: 2px;\n    height: 2px;\n    content: '';\n    background: #696969;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 5px;\n}\n}\n@media only screen and (min-width: 1025px) {\n.jaguar-style .services__item[data-v-08a81ef8]:first-child::before {\n    width: 2px;\n    height: 2px;\n    content: '';\n    background: #696969;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 5px;\n}\n.jaguar-style .services__item[data-v-08a81ef8]:not(:last-child)::after {\n    content: \",\";\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 5px;\n}\n}\n.services__item .step-info__value[data-v-08a81ef8] {\n  display: inline !important;\n}\n", "", {"version":3,"sources":["/var/www/jlr/booking-widget/src/pages/maintenance/MaintenanceSteps.vue"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,iBAAiB;CAClB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;CACf;AACD;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;CACjB;CACA;AACD;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;CACjB;AACD;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;CACrB;CACA;AACD;EACE,2BAA2B;CAC5B","file":"MaintenanceSteps.vue","sourcesContent":["/* # Setup devices width */\n/* # Variables for mobile first approach and strict ranges */\n.services__list[data-v-08a81ef8] {\n  text-align: left;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.services__item[data-v-08a81ef8] {\n  display: inline-block;\n}\n.land-rover-style .services__item[data-v-08a81ef8]::before {\n  width: 4px;\n  height: 4px;\n  content: '';\n  background: #696969;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 5px;\n}\n@media screen and (max-width: 1024px) {\n.jaguar-style .services__item[data-v-08a81ef8]::before {\n    width: 2px;\n    height: 2px;\n    content: '';\n    background: #696969;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 5px;\n}\n}\n@media only screen and (min-width: 1025px) {\n.jaguar-style .services__item[data-v-08a81ef8]:first-child::before {\n    width: 2px;\n    height: 2px;\n    content: '';\n    background: #696969;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 5px;\n}\n.jaguar-style .services__item[data-v-08a81ef8]:not(:last-child)::after {\n    content: \",\";\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 5px;\n}\n}\n.services__item .step-info__value[data-v-08a81ef8] {\n  display: inline !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "CmYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/cookieHelper.js
var cookieHelper = __webpack_require__("QELf");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/maintenance/MaintenanceSteps.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MaintenanceSteps = ({
    name: 'MaintenanceSteps',

    computed: {
        cityInfo: function cityInfo() {
            var city = this.$store.state.userLocation.description;
            if (city) {
                return city.split(',', 1).join();
            } else {
                return '';
            }
        },
        modelInfo: function modelInfo() {
            return {
                model: this.$store.state.maintenanceSelected.vehicleInfo.model,
                air: this.$store.state.maintenanceSelected.vehicleInfo.air,
                fuel: this.$store.state.maintenanceSelected.vehicleInfo.fuel,
                engine: this.$store.state.maintenanceSelected.vehicleInfo.engine,
                year: this.$store.state.maintenanceSelected.vehicleInfo.year
            };
        },
        dealerInfo: function dealerInfo() {
            return this.$store.state.maintenanceSelected.dealer;
        },
        servicesInfo: function servicesInfo() {
            return this.$store.getters.maintenanceFormattedServices;
        },
        reviewCampaignsInfo: function reviewCampaignsInfo() {
            return this.$store.state.maintenanceSelected.reviewCampaigns;
        },
        totalCost: function totalCost() {
            return this.$store.getters.maintenanceTotalCost;
        },
        dateTimeInfo: function dateTimeInfo() {
            return this.$store.getters.maintenanceFormattedTime;
        },
        clientInfo: function clientInfo() {
            return this.$store.state.maintenanceSelected.clientInfo;
        }
    },

    watch: {
        '$route': 'scrollToStepBeginning'
    },

    methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])(['clearMaintenanceDealer', 'clearMaintenanceServices', 'clearMaintenanceDateTime']), {
        scrollToStepBeginning: function scrollToStepBeginning() {
            var _this = this;

            if (this.$route.name !== 'MaintenanceFinish') {
                var interval = setInterval(function () {
                    var routeRootElement = _this.$slots[_this.$route.name][0].elm;
                    if (routeRootElement) {
                        _this.$scrollTo(routeRootElement);
                        clearInterval(interval);
                    }
                }, 100);
            }
        },
        backToStep: function backToStep(name) {
            switch (name) {
                case 'MaintenanceVehicle':
                    {
                        this.clearMaintenanceDealer();
                        this.clearMaintenanceServices();
                    }
                case 'MaintenanceServices':
                    this.clearMaintenanceDateTime();
            }
            this.$router.push({ name: name });
        },
        showStepDetails: function showStepDetails(name) {
            var result = void 0;
            switch (name) {
                case 'MaintenanceServices':
                    result = this.dealerInfo.name && (this.$route.name === 'MaintenanceTime' || this.$route.name === 'MaintenanceContacts' || this.$route.name === 'MaintenanceConfirmation');
                    break;
                case 'MaintenanceTime':
                    result = this.dateTimeInfo.title && (this.$route.name === 'MaintenanceContacts' || this.$route.name === 'MaintenanceConfirmation');
                    break;
                case 'MaintenanceContacts':
                    result = this.clientInfo.phone && this.$route.name === 'MaintenanceConfirmation';
                    break;
            }
            return result;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a81ef8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/maintenance/MaintenanceSteps.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$router.currentRoute.name === 'MaintenanceFinish')?_c('div',[_vm._t("MaintenanceFinish")],2):_c('div',{staticClass:"steps"},[_vm._t("MaintenanceVehicle",[_c('div',{staticClass:"step _completed"},[_c('div',{staticClass:"step-name _vehicle"},[_vm._v("\n                    "+_vm._s(_vm.$t('stepNames.carAndDealer'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"step-edit",on:{"click":function($event){return _vm.backToStep('MaintenanceVehicle')}}},[_c('span',{staticClass:"step-edit__text"},[_vm._v(_vm._s(_vm.$t('stepNames.edit')))])]),_vm._v(" "),_c('div',{staticClass:"step-info"},[_c('ul',{staticClass:"step-info__list"},[_c('li',{staticClass:"step-info__item"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('common.model')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.modelInfo.model.name))])]),_vm._v(" "),_c('li',{staticClass:"step-info__item"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('maintenance.airType')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.modelInfo.air.name))])]),_vm._v(" "),_c('li',{staticClass:"step-info__item"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('maintenance.engineSize')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.modelInfo.engine.name))])]),_vm._v(" "),_c('li',{staticClass:"step-info__item"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('maintenance.fuel')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.modelInfo.fuel.name))])]),_vm._v(" "),_c('li',{staticClass:"step-info__item"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('maintenance.modelYear')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.modelInfo.year.name))])]),_vm._v(" "),_c('li',{staticClass:"step-info__item",class:{'_dealer-completed':  !(_vm.$route.name === 'MaintenanceDealer')}},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('maintenance.city')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.cityInfo))])])]),_vm._v(" "),(!(_vm.$route.name === 'MaintenanceDealer'))?_c('div',{staticClass:"step-info__block"},[_c('div',{staticClass:"step-info__name"},[_vm._v("\n                            "+_vm._s(_vm.dealerInfo.name)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"step-info__value _address"},[_vm._v("\n                            "+_vm._s(_vm.dealerInfo.address)+"\n                        ")])]):_vm._e()])])]),_vm._v(" "),_vm._t("MaintenanceDealer"),_vm._v(" "),_vm._t("MaintenanceTime",[_c('div',{staticClass:"step",class:[_vm.showStepDetails('MaintenanceTime') ? '_completed' : '_disabled']},[_c('div',{staticClass:"step-name _time"},[_vm._v("\n                    "+_vm._s(_vm.$t('stepNames.dateAndTime'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"step-info"},[_c('div',{staticClass:"step-info__name"},[_vm._v("\n                        "+_vm._s(_vm.dateTimeInfo.title)+"\n                    ")])]),_vm._v(" "),_c('button',{staticClass:"step-edit",on:{"click":function($event){return _vm.$router.push({name: 'MaintenanceTime'})}}},[_c('span',{staticClass:"step-edit__text"},[_vm._v(_vm._s(_vm.$t('stepNames.edit')))])])])]),_vm._v(" "),_vm._t("MaintenanceContacts",[_c('div',{staticClass:"step",class:[_vm.showStepDetails('MaintenanceContacts') ? '_completed' : '_disabled']},[_c('div',{staticClass:"step-name _contacts"},[_vm._v("\n                    "+_vm._s(_vm.$t('stepNames.contacts'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"step-info"},[_c('ul',{staticClass:"step-info__list _few-item"},[_c('li',{staticClass:"step-info__item"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('common.firstName')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.clientInfo.firstName)+" "+_vm._s(_vm.clientInfo.middleName)+" "+_vm._s(_vm.clientInfo.lastName))])]),_vm._v(" "),_c('li',{staticClass:"step-info__item _phone"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('common.telephone')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value"},[_vm._v(_vm._s(_vm.clientInfo.phone))])]),_vm._v(" "),_c('li',{staticClass:"step-info__item _email"},[_c('span',{staticClass:"step-info__name"},[_vm._v(_vm._s(_vm.$t('common.email')))]),_vm._v(" "),_c('span',{staticClass:"step-info__value "},[_vm._v(_vm._s(_vm.clientInfo.email))])])])]),_vm._v(" "),_c('button',{staticClass:"step-edit",on:{"click":function($event){return _vm.$router.push({name: 'MaintenanceContacts'})}}},[_c('span',{staticClass:"step-edit__text"},[_vm._v(_vm._s(_vm.$t('stepNames.edit')))])])])]),_vm._v(" "),_vm._t("MaintenanceConfirmation",[_c('div',{staticClass:"step _disabled"},[_c('div',{staticClass:"step-name _confirmation"},[_vm._v("\n                    "+_vm._s(_vm.$t('stepNames.confirmation'))+"\n                ")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var maintenance_MaintenanceSteps = (esExports);
// CONCATENATED MODULE: ./src/pages/maintenance/MaintenanceSteps.vue
function injectStyle (ssrContext) {
  __webpack_require__("cPwW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08a81ef8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MaintenanceSteps,
  maintenance_MaintenanceSteps,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_maintenance_MaintenanceSteps = (Component.exports);

// EXTERNAL MODULE: ./src/components/SessionExpired.vue + 2 modules
var SessionExpired = __webpack_require__("whM1");

// EXTERNAL MODULE: ./src/components/LimitExceeded.vue + 1 modules
var LimitExceeded = __webpack_require__("Tsof");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/maintenance/Maintenance.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Maintenance = ({
    name: 'Maintenance',

    data: function data() {
        return {
            limitExceeded: false,
            readyToRenderForm: false,
            sessionIsExpired: false,
            showExpirationMessage: false
        };
    },


    computed: {
        unforeseenSessionExpiration: function unforeseenSessionExpiration() {
            return this.$store.state.maintenance.unforeseenSessionExpiration;
        },
        sessionId: function sessionId() {
            return this.$store.state.maintenance.sessionId;
        },
        sessionExpirationTime: function sessionExpirationTime() {
            return this.$store.state.maintenance.sessionExpirationTime;
        },
        formIsClean: function formIsClean() {
            return this.$route.name === 'MaintenanceVehicle';
        },
        expirationTime: function expirationTime() {
            return this.$store.state.maintenanceLimit.expirationTime;
        },
        requestLimit: function requestLimit() {
            return this.$store.state.maintenanceLimit.limit;
        }
    },

    watch: {
        sessionIsExpired: function sessionIsExpired() {
            if (this.sessionIsExpired) {
                if (this.sessionExpirationTime >= Date.now() && !this.unforeseenSessionExpiration) {
                    this.sessionIsExpired = false;
                    this.setSessionTimer();
                } else if (!this.formIsClean) {
                    this.showExpirationMessage = true;
                } else {
                    this.initSession();
                }
            } else {
                this.showExpirationMessage = false;
            }
        },
        unforeseenSessionExpiration: function unforeseenSessionExpiration() {
            if (this.unforeseenSessionExpiration) {
                this.sessionIsExpired = true;
            }
        },
        $route: function $route(currentRoute, previousRoute) {
            if (previousRoute.name === 'MaintenanceFinish') {
                this.$router.push({ name: 'MaintenanceVehicle' });
                this.initSession();
            }
        }
    },

    methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])(['clearMaintenanceForm']), {
        goToFirstStep: function goToFirstStep() {
            this.clearMaintenanceForm();
            this.$router.push({ name: 'MaintenanceVehicle' });
        },
        getSessionId: function getSessionId() {
            var _this = this;

            return this.$store.dispatch('setMaintenanceSessionId').then(function () {
                _this.sessionIsExpired = false;
            });
        },
        setSessionTimer: function setSessionTimer() {
            var _this2 = this;

            this.readyToRenderForm = true;
            setTimeout(function () {
                _this2.sessionIsExpired = true;
            }, this.sessionExpirationTime - Date.now());
        },
        initSession: function initSession() {
            var _this3 = this;

            this.getSessionId().then(function () {
                _this3.setSessionTimer();
            });
        },
        changeOfSessions: function changeOfSessions() {
            this.initSession();
            this.goToFirstStep();
        },
        checkExcessLimit: function checkExcessLimit() {
            var now = Date.now() / 1000;
            if (now > this.expirationTime) {
                this.$store.dispatch('setMaintenanceLimit').then(function () {
                    cookieHelper["a" /* cookieHelper */].set('OSB_ORDERS_COUNTER', 0);
                });
            } else {
                var ordersCounter = cookieHelper["a" /* cookieHelper */].get('OSB_ORDERS_COUNTER');
                if (ordersCounter >= this.requestLimit && this.requestLimit !== 0) {
                    this.limitExceeded = true;
                }
            }
        }
    }),

    created: function created() {
        this.checkExcessLimit();
        if (this.sessionExpirationTime >= Date.now()) {
            this.setSessionTimer();
        } else if (this.$route.name !== 'MaintenanceFinish') {
            this.initSession();
        } else {
            this.$router.push({ name: 'MaintenanceVehicle' });
        }
    },


    components: {
        MaintenanceSteps: pages_maintenance_MaintenanceSteps,
        SessionExpired: SessionExpired["a" /* default */],
        LimitExceeded: LimitExceeded["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a30432e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/maintenance/Maintenance.vue
var Maintenance_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maintenance",attrs:{"prop-lid":"prod"}},[(!_vm.limitExceeded)?_c('div',{staticClass:"test-drive__form"},[(_vm.readyToRenderForm)?_c('maintenance-steps',[_c('router-view',{attrs:{"slot":_vm.$route.name},slot:_vm.$route.name})],1):_c('step-preloader'),_vm._v(" "),(_vm.showExpirationMessage)?_c('session-expired',{on:{"startOver":_vm.changeOfSessions}}):_vm._e()],1):_c('limit-exceeded')],1)}
var Maintenance_staticRenderFns = []
var Maintenance_esExports = { render: Maintenance_render, staticRenderFns: Maintenance_staticRenderFns }
/* harmony default export */ var maintenance_Maintenance = (Maintenance_esExports);
// CONCATENATED MODULE: ./src/pages/maintenance/Maintenance.vue
var Maintenance_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Maintenance___vue_template_functional__ = false
/* styles */
var Maintenance___vue_styles__ = null
/* scopeId */
var Maintenance___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Maintenance___vue_module_identifier__ = null
var Maintenance_Component = Maintenance_normalizeComponent(
  Maintenance,
  maintenance_Maintenance,
  Maintenance___vue_template_functional__,
  Maintenance___vue_styles__,
  Maintenance___vue_scopeId__,
  Maintenance___vue_module_identifier__
)

/* harmony default export */ var pages_maintenance_Maintenance = __webpack_exports__["default"] = (Maintenance_Component.exports);


/***/ }),

/***/ "Tsof":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c9eb5c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LimitExceeded.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"limit-exceeded"},[_c('div',{staticClass:"limit-exceeded__title steps-title"},[_vm._v("\n        "+_vm._s(_vm.$t('common.limitExceededTitle'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"limit-exceeded__message"},[_vm._v("\n        "+_vm._s(_vm.$t('common.limitExceededMessage'))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var LimitExceeded = (esExports);
// CONCATENATED MODULE: ./src/components/LimitExceeded.vue
function injectStyle (ssrContext) {
  __webpack_require__("wGUm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  LimitExceeded,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_LimitExceeded = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cPwW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/4dF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7a25839f", content, true, {});

/***/ }),

/***/ "smwW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("uZg5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("297772f2", content, true, {});

/***/ }),

/***/ "uZg5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.session-expired__title {\n  padding: 0 0 20px;\n  font-size: 16px;\n  letter-spacing: 1px;\n  word-spacing: 3px;\n  text-transform: uppercase;\n}\n.session-expired__button {\n  width: 100%;\n}\n.session-expired .modal-window__container {\n  overflow: hidden;\n}\n.session-expired .modal-window__close {\n  display: none;\n}\n", "", {"version":3,"sources":["/var/www/jlr/booking-widget/src/components/SessionExpired.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;CAC3B;AACD;EACE,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;EACE,cAAc;CACf","file":"SessionExpired.vue","sourcesContent":["\n.session-expired__title {\n  padding: 0 0 20px;\n  font-size: 16px;\n  letter-spacing: 1px;\n  word-spacing: 3px;\n  text-transform: uppercase;\n}\n.session-expired__button {\n  width: 100%;\n}\n.session-expired .modal-window__container {\n  overflow: hidden;\n}\n.session-expired .modal-window__close {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "wGUm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+CoK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("938eb064", content, true, {});

/***/ }),

/***/ "whM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/ModalWindow.vue + 2 modules
var ModalWindow = __webpack_require__("o46f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SessionExpired.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SessionExpired = ({
    name: 'SessionExpired',
    methods: {
        startOver: function startOver() {
            this.$emit('startOver');
        }
    },
    components: {
        ModalWindow: ModalWindow["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24fe932c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SessionExpired.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-window',{staticClass:"session-expired"},[_c('div',{staticClass:"session-expired__wrapper"},[_c('div',{staticClass:"session-expired__title"},[_vm._v("\n            "+_vm._s(_vm.$t('common.sessionExpired'))+"\n        ")]),_vm._v(" "),_c('submit-button',{staticClass:"session-expired__button",on:{"click":_vm.startOver}},[_vm._v("\n            "+_vm._s(_vm.$t('common.startOver'))+"\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_SessionExpired = (esExports);
// CONCATENATED MODULE: ./src/components/SessionExpired.vue
function injectStyle (ssrContext) {
  __webpack_require__("smwW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SessionExpired,
  components_SessionExpired,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_SessionExpired = __webpack_exports__["a"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/5.4aca873bde783fa78ce1.js